import { render, staticRenderFns } from "./lut.vue?vue&type=template&id=1501345b&"
import script from "./lut.vue?vue&type=script&lang=js&"
export * from "./lut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports